import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import EmailTemplateContent from "./EmailTemplateContent";
import NoMobileView from "./NoMobileView";

export default function EmailTemplatesManagement() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <NoMobileView />
        </>
      ) : (
        <>
          <Navbar linkActive={17} />
          <EmailTemplateContent />
        </>
      )}
    </div>
  );
}
